export const TEXT_KEYS = {
    HEADER_LOGIN: 'header__login',
    HEADER_LOGOUT: 'header__logout'
};

export const OVERLAY_ID = 'overlay-widget';
